import { Controller } from '@hotwired/stimulus';

export default class ToastDemoController extends Controller {
  static values = { message: String, title: String };

  show() {
    window.toastr?.success(this.messageValue, this.titleValue, { closeButton: true });
  }
}
